import { render } from "./CreditDocumentsComponent.vue?vue&type=template&id=7df19174&scoped=true"
import script from "./CreditDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./CreditDocumentsComponent.vue?vue&type=script&lang=js"

import "./CreditDocumentsComponent.vue?vue&type=style&index=0&id=7df19174&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df19174"]])

export default __exports__